import React, { PureComponent } from 'react'
import classnames from 'classnames'
import BaseIcon from './BaseIcon'

const MaterialIcon = props => {
  return <BaseIcon {...props} family="materialicon" />
}

export default MaterialIcon
